<template>
  <div class="h-full">
    <div class="flex h-full">
      <Suspense>
        <template #default>
          <HistoryContainer
            :templateId="templateId"
            :locationId="locationId"
            :service="service"
            class="w-96 border"
            @update:version="switchPreview"
          />
        </template>
        <template #fallback>
          <div class="w-96 border">
            <UILoading />
          </div>
        </template>
      </Suspense>
      <div class="w-full">
        <UILoading v-if="state.loading" />
        <IframeComponent :html="state.previewData" v-else />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, watch } from 'vue'
import HistoryContainer from './HistroyContainer.vue'
import { UILoading, UIButton, UIIcon } from '@gohighlevel/ghl-canvas'
import IframeComponent from '../Preview/IframeComponent.vue'
import { Item as IItem } from '../../types'
export default defineComponent({
  props: {
    templateId: {
      type: String,
      required: true,
    },
    locationId: {
      type: String,
      required: true,
    },
    userId: { type: String, required: true },
    service: {
      type: Object,
      required: true,
    },
  },
  components: {
    HistoryContainer,
    UILoading,
    UIButton,
    IframeComponent,
    UIIcon,
  },
  setup(props, { emit }) {
    const state = reactive({
      previewData: '',
      loading: false,
      activeVersion: '',
    })
    fetchPreviewData()
    async function fetchPreviewData(version: number = 0) {
      state.loading = true
      const { data } = await props.service.getHtmlPreview({
        id: props.templateId as string,
        locationId: props.locationId as string,
        version,
      })
      state.previewData = data
      state.loading = false
    }
    watch(
      () => props.templateId,
      () => fetchPreviewData()
    )
    function switchPreview(item: IItem) {
      emit('update:version', item)
      fetchPreviewData(item.id)
      state.activeVersion = item.versionId
    }
    async function switchVersions() {
      try {
        const params = {
          templateId: props.templateId as string,
          versionId: state.activeVersion,
          updatedBy: props.userId,
          locationId: props.locationId as string,
        }
        await props.service.switchVersion(params)
      } catch (error) {
        console.error(error)
      }
    }
    return {
      switchPreview,
      state,
      switchVersions,
    }
  },
})
</script>

<style scoped>
iframe {
  width: 100%;
  height: 100vh;
}
</style>
